import { FC, useCallback } from 'react';
import { Checkbox } from 'framework/checkbox';

import { GridHeader } from './GridHeader';
import { GridHeaderCheckboxProps } from './types';

export const GridCheckboxHeader: FC<GridHeaderCheckboxProps> = ({ column, index, style }) => {
  const { label, checked, onClick } = column.props;

  const onMouseDown = useCallback(() => onClick(!checked), [checked, onClick]);

  return (
    <GridHeader onMouseDown={onMouseDown} column={column} index={index} style={style}>
      <Checkbox checked={checked} right_label={label} width="fit-content" />
    </GridHeader>
  );
};
